import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar/Sidebar'; 
import voiceThumbnail from '../../src/assets/images/work/voice_sns/thumbnail.png';
import voiceDemo from '../../src/assets/video/voice_sns.mp4';
import mainScreen from '../../src/assets/images/work/voice_sns/snsui_main_screen.png';
import point_1 from '../../src/assets/images/work/voice_sns/point_1.png';
import point_list from '../../src/assets/images/work/voice_sns/point_list.png';
import { ReactComponent as ExternalLinkIcon } from '../../src/assets/icons/external_link.svg';
import './raiden/raiden.css'; 
import './SinglePost.css';

function VoiceSns() {
    // 見出し情報とアクティブな見出しを管理する状態
        const [headings, setHeadings] = useState([]);
        const [activeHeadingId, setActiveHeadingId] = useState(null);
    
        // コンテンツのDOMを参照するためのref
        const contentRef = useRef(null);
    
        // ① コンテンツを通常のJSXで記述
        const contentJSX = (
            <div>
                <div className="article-title-block">
                    <h1 className="article-title">音声SNSアプリ</h1>
                    <div className="article-sub-title"><strong>モバイルUIの基本パターンを学ぶ</strong></div>
                </div>
                            
                <div className="article-info">
                    <div className="use-tool">
                        <strong>使用ツール：</strong>Figma
                    </div>
                    <div className="product-period">
                    <strong>制作期間：</strong>3週間
                    </div>
                </div>
                
                <div className="thumbnail-block">
                    <div>
                        <img 
                            src={voiceThumbnail} 
                            alt="音声SNSアプリのサムネイル画像です。" 
                        /> 
                    </div>  
                </div>


                <section className="overview">
                    <h2>概要</h2>
                    <div className="section-content">
                        <p>
                        BONO(UI/UXが学べるコミュニティ)の課題として取り組んだ音声SNSアプリのモバイルUIデザインです。音声投稿に特化したSNSという想定のもと、新規登録・投稿フィード・投稿・検索・通知・設定といった主要な6つのUIパターンの基本を学ぶことを目的にデザインしました。あくまでUIのビジュアルを学ぶことをメインにしているため、情報設計は行なっていません。
                        </p>
                    </div>
                </section>

                <section className="prototype">
                    <h2>成果物</h2>
                    <div className="section-content">            
                    <div className="video-container">
                        <figure>
                            <video controls aria-describedby="video-desc" className="test-video">
                            <source src={voiceDemo} type="video/mp4" />
                            お使いのブラウザは動画をサポートしていません。
                            </video>
                            <figcaption id="video-desc">
                            この動画では、音声SNSアプリの新規登録〜投稿までの流れを画面録画したデモを紹介しています。
                            </figcaption>
                        </figure>
                    </div>

                    <div className="section-content">
                        <p>
                        SNS UIの主要な6画面（新規登録UI、投稿フィードUI、投稿UI、検索UI、通知UI、設定UI）を作成しました。
                        </p>
                        <div className="img-container"> 
                            <img 
                                src={mainScreen} 
                                alt="音声SNSアプリの6つの画面が表示されています。" 
                            />
                        </div>  

                    </div>
                        
                    </div>
                </section>


                <section className="use-case">
                    <h2>ユースケース</h2>
                    <div className="section-content">
                        <p>
                        気軽に音声を投稿し、それをフォローしている人や興味を持った人が日常的に聞いて楽しむ、コミュニケーションの場を想定しています。音声コンテンツは移動中や作業中など、画面を注視しづらい状況でも利用しやすいのが特徴です。利用者は「音声を投稿する人」と「音声を聞く人」が入り混じり、他ユーザーが投稿したさまざまな音声に気軽にアクセスし、コミュニケーションが行われるシーンを想定しました。
                        </p>
                    </div>
                </section>

                <section className="purpose">
                    <h2>目的</h2>
                    <div className="section-content">
                    <p>ユーザーが音声を通じて情報や感情を気軽に共有し、新たなコミュニケーションやつながりを広げることを目指す。</p>
                </div>
                </section>

                <section className="point">
                    <h2>デザインのポイント</h2>
                    <div className="section-content">
                        <p className="section-lead-text">ここでは特に工夫した<strong>投稿フィードUI</strong>について取り上げます。</p>
                    
                        <div className="ui-point">
                            <h3>投稿フィードUI</h3>
                            <p  className="ui-description">
                                音声SNSにおいて、投稿フィードはユーザーが日常的に触れる最も重要な導線です。ここでは<strong>「どの投稿を聞くか」を素早く判断できる一覧性</strong>と、<strong>「音声に集中する」ための視覚的ノイズの少なさ</strong>が求められます。こうした要件を満たすため、<strong>情報をシンプルに構造化でき、コンテンツ同士の比較もしやすいリストUIを選定</strong>しました。視線の移動を最小限に抑えることで、ユーザーの意識を音声体験に自然と導く設計を目指しています。
                            </p> 
                            <div className="ui-img"> 
                                <img 
                                    src={point_1} 
                                    alt="左側にリストUIで構成された投稿フィード画面が表示されており、右側にリストUIを選定した理由が簡潔に述べられています。" 
                                />
                            </div>    
                            <p  className="ui-description">
                                当初は投稿を魅力的に見せることを重視し、カードUIを想定していました。しかし、<strong>カードUIは視覚的に目立つ要素が多い</strong>ため、「詳細を見に行く」「画像や装飾に注目する」といった行動が促されやすく、結果として<strong>音声体験への導線が遠のいてしまう</strong>懸念がありました。音声中心の体験設計には、カードUIの構造は必ずしも最適とはいえないと判断しました。
                            </p> 
                            <div className="ui-img"> 
                                <img 
                                    src={point_list} 
                                    alt="左側にカードUIで構成された投稿フォード画面が表示されており、右側にカードUIのデメリット、カードUIが向いているアプリ例を簡潔に述べられています。" 
                                />
                            </div> 
                        </div> 
                    </div>  
                </section>

                <section className="summary">
                <h2>学んだこと</h2>
                <div className="section-content">
                    <p>本課題を通じて、SNSアプリに必要とされる主要画面を一通り学ぶことで、モバイルUIの基本的なレイアウトや操作フローの組み立て方を実践的に理解できました。特に「どのタイミングでどの情報を提示するか」や「ユーザーにどのような行動を取らせるか」というUXの視点と、余計なノイズを省いて情報を整然と配置するUIの視点のバランスを取る難しさを実感し、今後より複雑な情報設計が求められるアプリケーションにも応用できる基礎的な知見を得ることができました。</p>
                </div>
                </section>


                <section>
                    <div className="section-content">
                        <p>音声SNSアプリのfigmaファイルは、以下のリンクからアクセスできます。</p>
                        <a  className="site-link"
                            href="https://www.figma.com/design/CKdQHLrWYFjCQt67UPvZw2/%E9%9F%B3%E5%A3%B0SNS%E3%82%A2%E3%83%97%E3%83%AA?node-id=0-1&t=TNy61cN8K3mPGQq4-1" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            aria-label="音声SNSアプリのfigmaファイルを新しいタブで開きます"
                        >
                            音声SNSアプリのfigmaファイル
                            <ExternalLinkIcon className="external-link-icon" />
                        </a>
                    </div>
                </section>



            </div>

        );

        // ② コンテンツレンダリング後にrefから見出しを抽出する
      useEffect(() => {
        if (contentRef.current) {
          // querySelectorAllでh2, h3, h4タグを取得
          const headingEls = contentRef.current.querySelectorAll('h2, h3, h4');
          const extractedHeadings = [];
          headingEls.forEach((el, index) => {
            // IDがなければ自動で設定する
            if (!el.id) {
              el.id = `heading-auto-${index + 1}`;
            }
            // タグ名からレベルを数値として取得
            const level = parseInt(el.tagName.substring(1), 10);
            extractedHeadings.push({
              id: el.id,
              text: el.innerText,
              level: level,
            });
          });
          setHeadings(extractedHeadings);
        }
      }, []); // 一度だけ実行
    
      // ③ スクロールイベントでアクティブな見出しを更新（オプション）
      useEffect(() => {
        function handleScroll() {
          let currentActive = null;
          let minDistance = Infinity;
          headings.forEach(h => {
            const el = document.getElementById(h.id);
            if (el) {
              const rect = el.getBoundingClientRect();
              const distance = Math.abs(rect.top);
              if (distance < minDistance) {
                minDistance = distance;
                currentActive = h.id;
              }
            }
          });
          setActiveHeadingId(currentActive);
        }
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
      }, [headings]);
    
      // ④ クリック時に対象の見出しへスクロールする処理
      const handleClickHeading = (headingId) => {
        const el = document.getElementById(headingId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };
    
    
        return (
            <div className="single-post-container">
          
            <div className="single-post-main"> 
              <div className="back-to-home">
                <Link to="/" className="back-link">← Homeへ戻る</Link>
              </div>
    
              <div className="single-post-content" ref={contentRef}>
                {contentJSX}
              </div>
    
              <div className="back-to-home">
                <Link to="/" className="back-link">← Homeへ戻る</Link>
              </div>
            </div>
      
            <Sidebar
              headings={headings}
              activeHeadingId={activeHeadingId}
              onClickHeading={handleClickHeading}
            />
            
          </div>
    
        );
        

    
}
export default VoiceSns;      